
export default (uploadImageFunc) => {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.click();

  // Listen upload local image and save to server
  input.onchange = () => {
    const file = input.files[0];

    // file type is only image.
    if (/^image\//.test(file.type)) {
      const fd = new FormData();
      fd.append('image', file);
      uploadImageFunc(fd)
    } else {
      console.warn('You could only upload images.');
    }
  };
};



// WEBPACK FOOTER //
// ./src/util/imageHandlerForRichTextInput.js